function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { formatCurrency } from "@vestwell-frontend/helpers";
import { useMemo } from "react";
export var FormatCurrency = function(_param) {
    var _param_precision = _param.precision, precision = _param_precision === void 0 ? 0 : _param_precision, prefix = _param.prefix, suffix = _param.suffix, value = _param.value, _param_showPlaceholder = _param.showPlaceholder, showPlaceholder = _param_showPlaceholder === void 0 ? false : _param_showPlaceholder, _param_stripTrailingZeros = _param.stripTrailingZeros, stripTrailingZeros = _param_stripTrailingZeros === void 0 ? false : _param_stripTrailingZeros, options = _object_without_properties(_param, [
        "precision",
        "prefix",
        "suffix",
        "value",
        "showPlaceholder",
        "stripTrailingZeros"
    ]);
    var formatted = useMemo(function() {
        var result = formatCurrency(value, _object_spread_props(_object_spread({}, options), {
            /** prevents error from INTL formatting */ maximumFractionDigits: precision,
            minimumFractionDigits: precision,
            showPlaceholder: showPlaceholder,
            stripTrailingZeros: stripTrailingZeros
        }));
        return (result === null || result === undefined || result === '') && showPlaceholder ? '--' : result;
    }, [
        options,
        value
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            value !== '--' && prefix ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    prefix,
                    " "
                ]
            }) : '',
            formatted,
            value !== '--' && suffix ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    " ",
                    suffix
                ]
            }) : ''
        ]
    });
};
FormatCurrency.displayName = 'FormatCurrency';

//# sourceMappingURL=FormatCurrency.js.map